import React from 'react';
import {
  Container,
  Typography,
  Paper,
  Box,
  Button
} from '@material-ui/core';
import { ReportProblemOutlined } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';

const ErrorScreenPermission = () => {
  const history = useHistory();

  return (
    <Container maxWidth="sm">
      <Paper elevation={3}>
        <Box p={4} textAlign="center">
          <ReportProblemOutlined style={{ fontSize: 80, color: '#f44336' }} />
          <Typography variant="h5" gutterBottom color="error">
            ¡Acceso Denegado!
          </Typography>
          <Typography variant="body1" color="textSecondary" paragraph>
            No fue posible validar los permisos del usuario, o no cuenta con los permisos necesarios
            para acceder a esta sección del sistema.
          </Typography>
          <Button variant="contained" color="primary" onClick={() => history.push('/')}>
            Ir al inicio
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default ErrorScreenPermission;